<button class="close float-right" matDialogClose>&times;</button>
<h2 mat-dialog-title>Parâmetros de execução</h2>
<mat-dialog-content class="mat-typography">
  <div mat-dialog-content class="mat-typography" style="max-height: 100%">
    <div class="row">
      <table class="table">
        <thead>
          <tr>
            <th *ngIf="data.carteira != null || data.grupoCarteira == null">Carteira</th>
            <th *ngIf="data.grupoCarteira != null">Grupo de Carteira</th>
            <th>Regra</th>
            <th>Status</th>
            <th>Data Início</th>
            <th>Data Fim</th>
          </tr>
        </thead>
        <tbody>
          <tr class="element-row">
            <td *ngIf="data.carteira != null || data.grupoCarteira == null">{{ data.carteira }}</td>
            <td *ngIf="data.grupoCarteira != null">{{ data.grupoCarteira }}</td>
            <td>{{ data.regra }}</td>
            <td>{{ data.status }}</td>
            <td>{{ data.dataInicio | date : "dd/MM/yyyy" }}</td>
            <td>{{ data.dataFim | date : "dd/MM/yyyy" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</mat-dialog-content>
